import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchDataFromAPI } from 'app/components/ReusableUIComponents/HighLevelComponents/DataGridMAIQ/api/dataGridApiService';

const HIL_TEMPLATES_ENDPOINT = 'api/v2/templates';

export interface UsePendingApprovalTemplatesCountResult {
  count: number;
  isLoading: boolean;
  isError: boolean;
}

export function usePendingApprovalTemplatesCount(
  dealerId: string | undefined,
): UsePendingApprovalTemplatesCountResult {
  const safeDealerId = dealerId ? String(dealerId) : '';
  const { data, isLoading, isError } = useQuery({
    queryKey: ['hil-templates-pending-count', safeDealerId],
    enabled: Boolean(safeDealerId),
    queryFn: () =>
      fetchDataFromAPI(
        HIL_TEMPLATES_ENDPOINT,
        {
          dealer: safeDealerId,
          status: 'PENDING_APPROVAL',
        },
        1,
        1,
      ),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });

  const count = useMemo(() => {
    const totalDocuments = data?.body?.meta?.totalDocuments;
    const numericCount = Number(totalDocuments);
    return Number.isFinite(numericCount) && numericCount >= 0 ? numericCount : 0;
  }, [data]);

  return {
    count,
    isLoading,
    isError,
  };
}
